import { inject, observer } from 'mobx-react';
import React from 'react';
import { TvPackageOfferingCards, TvPackageOfferingCardsProps } from '@teliaee/telia-common-components';
import { Grid, GridColumn } from 'telia-front-react';
import config from '../Config';
import LanguageStore from '../stores/LanguageStore';
import SsoStore, { CUSTOMER_TYPE_PRIVATE } from '../stores/SsoStore';

type TvPackagesProps = Omit<TvPackageOfferingCardsProps, 'tier' | 'app' | 'language' | 'tvPackageStore' | 'translations' | 'translate'>;

export interface TvPackageOfferingCardsContainerProps extends TvPackagesProps {
  languageStore?: LanguageStore;
  ssoStore?: SsoStore;
}

@observer
class TvPackageOfferingCardsContainer extends React.Component<TvPackageOfferingCardsContainerProps> {
  public render() {
    const { packageData, headingLevel, variant, viewerSlotIcon, languageStore, ssoStore, isTestEnvironment, disableTranslationsStatistics } = this.props;

    return (
      <Grid align={['center-xs']}>
        <GridColumn width={['xs-12', 'md-10']}>
          <TvPackageOfferingCards
            packageData={packageData}
            headingLevel={headingLevel}
            viewerSlotIcon={viewerSlotIcon}
            variant={variant}
            tier={config.componentTier}
            language={languageStore.currentLanguage}
            app={'public'}
            generateBasketId={ssoStore.customerType === CUSTOMER_TYPE_PRIVATE}
            customerId={ssoStore.customerId}
            isTestEnvironment={isTestEnvironment}
            disableTranslationsStatistics={disableTranslationsStatistics}
          />
        </GridColumn>
      </Grid>
    );
  }
}

export default inject('languageStore', 'ssoStore')(TvPackageOfferingCardsContainer);
